import Api from '@/services/Api'
import router from '@/router'
import store from '@/store'

export default {
  bookList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending) {
        param += ' desc'
      }
    }

    // console.log('param', param)
    // console.log('credentials', credentials)
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=List' + param,
      credentials
    )
  },
  bookByID(credentials) {
    // console.log('credentials', credentials)
    var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Details' + param,
      credentials
    )
  },
  PermissionByID(credentials) {
    // console.log('credentials', credentials)
    var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Permission_ByID' + param,
      credentials
    )
  },
  bookStatusByID(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Status' + param,
      credentials
    )
  },
  PermissionAdd(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Permission_insert' + param,
      credentials
    )
  },
  PermissionUpdate(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Permission_Update' + param,
      credentials
    )
  },
  PermDelete(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Permission_Delete' + param,
      credentials
    )
  },
  bookAdd(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=insert' + param,
      credentials
    )
  },
  bookUpdate(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=update' + param,
      credentials
    )
  },
  UpdateStatus(credentials) {
    // console.log('credentials', credentials)
    var param = '&ID=' + credentials.ID
    // param += '&status=' + credentials.status
    // param += '&modifyCode=' + credentials.modifyCode
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=updatestatus' + param,
      credentials
    )
  },
  DT_list(credentials) {
    // console.log('credentials', credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending) {
        param += ' desc'
      }
    }
    // console.log('param', param)
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=DT_list' + param,
      credentials
    )
  },
  DTByID(credentials) {
    // console.log('credentials', credentials)
    var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=DT_Details' + param,
      credentials
    )
  },
  DT_insert(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=DT_insert' + param,
      credentials
    )
  },
  DT_update(credentials) {
    // console.log('credentials', credentials)
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=DT_update',
      credentials
    )
  },
  getEmp(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=getEmp' + param,
      credentials
    )
  },
  getDep(credentials) {
    // console.log('credentials', credentials)
    var param // = '&id=' + credentials.id
    // console.log('param', param)
    param = ''
    return Api.httpServer().post(
      'model_tb/default.asp?controller=Emp&action=getDep' + param,
      credentials
    )
  },
  getNotificate(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Notificate',
      credentials
    )
  },
  delNotificate(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=NotificateDel',
      credentials
    )
  },
  getFile(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=getfile',
      credentials
    )
  },
  getFileV2(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=pfile&action=getfile',
      credentials
    )
  },
  getPermission(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Permission',
      credentials
    )
  },
  bookDelete(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=delete',
      credentials
    )
  },
  SendMail(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=Send',
      credentials
    )
  },
  bookDTDelete(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=DT_delete',
      credentials
    )
  },
  dashboard(credentials) {
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=dashboard',
      credentials
    )
  },
  getListByEmp(credentials) {
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending) {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'model_tb/default.asp?controller=bookIn&action=ListByEmp' + param,
      credentials
    )
  },
  errorHandel(res) {
    console.log('res', res.status)
    if (res.status === 401) {
      store.state.users.main = {}
      router.push('/signin')
    }
  }
}
